import easydropdown from 'easydropdown';

export default class DropdownMenu {

	static init() {
		// init easy dropdown and destroy all instances inside flatpickr
		easydropdown.all();
		const flatpickrInstances = document.querySelectorAll('.flatpickr-calendar select');
		flatpickrInstances.forEach((select) => {
			const edd = easydropdown(select);
			edd.destroy();
		});
	}
}
